'use client';

import { Box, Flex, Heading, Text, Image, For, Link } from "@chakra-ui/react";
import { useEffect } from 'react';
import Advertising from '@/components/Advertising';
import { InnerHtml } from "@/components/partials/Helpers";
import ContentBox from "@/components/partials/ContentBox";
import Gallery from "@/components/Gallery";
import SocialShare from "@/components/SocialShare";
import RelatedPosts from "@/components/RelatedPosts";
import { headerDated } from "@/helpers/utils";
import { LuTimer, LuLoaderCircle } from "react-icons/lu"
import { keyframes } from '@emotion/react';
import analytics from "@/lib/analytics";

export default function SinglePage({ data, ads, dated }) {
  if(!data) return null;

  useEffect(() => {
    if(data?.postToken) {
      analytics('pageview', data.postToken);
    };

    if(data?.postRedirect) {
      setTimeout(() => {
        window.location.href = data.postRedirect;
      }, 3000);
    }
  }, []);

  const spin = keyframes`
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  `;

  return (
    <Box>
      <Box my="8">
        <ContentBox padding="0">
          { data.postCategories && data.postCategories.length > 0 && (
            <Flex>
              <For each={data.postCategories} >
                {(item, index) => (
                  <Box
                    key={index}
                    pb="4"
                    mr="2"
                  >
                    <Link
                      href={`/categoria/${item.taxSlug}`}
                      title={ item.taxName }
                      color="orange.500"
                      fontWeight="700"
                      fontSize="1.1em"
                      borderBottom="2px solid"
                      borderColor="yellow.500"
                      textTransform="uppercase"
                    >
                      { item.taxName } { data.postHat }
                    </Link>
                  </Box>
                )}
              </For>
            </Flex>
          )}


          <Heading as="h1" fontFamily="inherit" color="orange.500" fontWeight="700" fontSize={{base: '2em', md: '3em'}} pt="4" pb="6" lineHeight="1">
            { data.postTitle }
          </Heading>

          { data.postSubTitle && (
            <Heading as="h2" fontFamily="inherit" fontWeight="400" fontSize={{base: '1.1em', md: '1.3em'}} pb="6" lineHeight="1" color="gray.600">
              { data.postSubTitle }
            </Heading>
          )}

          <Flex alignItems="center" pb="2">
            <LuTimer />

            <Box as="time" dateTime={new Date(dated || data.createdAt).toISOString()} ml="2" textTransform="uppercase" fontSize="0.8em">
              { headerDated(dated || data.createdAt) }
            </Box>
          </Flex>

          {data.postAuthor && (
            <Text fontSize="0.8em" color="gray.500" pb="4">
              Por {data.postAuthor}
            </Text>
          )}

          <Box pb="6">
            <Advertising ads={ads?.superior[0]} />
          </Box>

          <Box pb="6">
            { Object.keys(data.postImages).length > 1 && (
              <>
              <Image
                src={ data.postImages?.find(i => i.mediaTyped === 'resized').mediaCdnUrl }
                alt={ data.postTitle }
              />

              <Box fontSize="0.8em" textTransform="uppercase">
                { data.postSource }
              </Box>
              </>
            )}
          </Box>

          <Box fontSize="1.2em" fontWeight="400" lineHeight="1.4em" minH="620px">
            <Box style={{ float: 'right', marginLeft: '1rem', marginBottom: '0.5rem' }} w={{base: '100%', md: 'auto'}}>
              <Box style={{ maxWidth: '315px' }}>
                <Advertising ads={ads?.texto[0]} />
              </Box>
            </Box>

            { data.postRedirect ? (
              <Flex flexDirection="column" justifyContent="center" alignItems="center" h="400px">
                <Box fontSize="1.2em">Você está redirecionado em segundos..</Box>

                <Box mt="8" animation={`${spin} 1s linear infinite`}>
                  <LuLoaderCircle size="60" color="orange.500"  />
                </Box>
              </Flex>
            ) : (
              <InnerHtml html={data.postContent}></InnerHtml>
            )}
          </Box>
        </ContentBox>
      </Box>

      { data.postAttachments && data.postAttachments.length > 0 && (
        <Box mb="8">
          <Gallery data={data.postAttachments} />
        </Box>
      )}

      <Box>
        <Advertising ads={ads?.inferior[0]} />
      </Box>

      <Box py="8">
        <SocialShare permalink={data.postPermalink} />
      </Box>

      <Box pb="8">
        <RelatedPosts posts={data.relatedPosts} />
      </Box>
    </Box>
  )
}
